import React from "react";
import { getZscalerURLParams } from "./../utilities/utilities";
import AttentionMessage from "../components/attention-message";
import Details from "../components/details";
import Disclaimer from "../components/disclaimer";
import Header from "../components/header";
import ReasonCode from "./../components/reason-code";
import SafetyNotice from "../safety-notice";
import ServiceNowLink from "../components/servicenow-link";
import SupportDirections from "./../components/support-directions";
import config from "../config";

const BlockPage = () => {
  const params = getZscalerURLParams();

  if (params.category !== 'Generative AI and ML Applications') {
    return (
      <div className="main fade-up">
        <Header content="Restricted Website Access" />
        <AttentionMessage content={`REASON CODE: ${params.reasoncode}`} />
        <div className="content fade-in">
          <ReasonCode code={params.reasoncode} />
          <div className="support-information">
            <h2>Support Information</h2>
            <p>
              <SupportDirections code={params.reasoncode} />
              <ServiceNowLink />
            </p>
            <Details />
          </div>
          <SafetyNotice />
          <Disclaimer />
        </div>
      </div>
    );
} else {
  return (
    <div className="main fade-up">
      <Header content="Restricted Website Access" />
      <AttentionMessage content={`REASON CODE: ${params.reasoncode}`} />

      <div className="content fade-in">
        <div className="exception-description">
          <p>
          You are no longer be able to access this AI tool that is outside of the Trinity Health secure environment. 
          However, Microsoft Copilot Chat is available as the Trinity Health-supported tool for AI assistance.
          </p>

          <AttentionMessage
            content={`Why Microsoft Copilot Chat`}
          />
          
          <p>
            <ul>
              <li>Fully integrated with our M365 environment</li>
              <li>Secure and compliant with Trinity Health policies</li>
              <li>Designed to help you work more efficiently</li>
            </ul>
          </p>
          <p>
          Access Microsoft Copilot Chat by clicking the Microsoft 365 Copilot icon in ZENworks or directly through this link:  <a href={config.services.msCopilotUrl} target="_blank">{config.services.msCopilotUrl}</a>
          </p>
        </div>
      </div>
      
      <div className="support-information">
        <h2>Support Information</h2>
        <Details />
      </div>
      <SafetyNotice />
      <Disclaimer />
    </div>
    );
  }
};

export default BlockPage;
